import React from 'react'
import InputField from '../../formFields/inputField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <InputField {...fieldProps} />
))
